import { render, staticRenderFns } from "./QuoteLabourSection.vue?vue&type=template&id=6570852a"
import script from "./QuoteLabourSection.vue?vue&type=script&lang=js"
export * from "./QuoteLabourSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports